<template>
  <div class="page">
    <section class="content-section">
      <h1>Kontaktaufnahme</h1>
      <div class="content-section-info" style="text-align:center" v-if="submitStatus != 'submitted' && formAvailable">Haben Sie Fragen oder möchten Sie gerne einen Beratungstermin vereinbaren?<br>Wir freuen uns auf Ihre Mitteilung!<br><br>Um auf Ihr Anliegen schnell reagieren zu können, benötigen wir einige Angaben.</div>
      <div class="submit-message" v-if="submitStatus == 'submitted'"><b>Vielen Dank für Ihre Anfrage!</b><br><br>Wir werden diese so schnell es uns möglich ist bearbeiten und uns dann umgehend mit Ihnen in Verbindung setzen!</div>
      <div class="disable-message" v-if="submitStatus != 'submitted' && !formAvailable"><b>Sie haben uns bereits eine Anfrage geschickt!</b><br><br>Das Kontaktformular wurde aus diesem Grund für einige Zeit deaktiviert...</div>
      <form v-if="formAvailable" id="contact" @submit.prevent="SubmitForm" action="#" method="POST" accept-charset="UTF-8" :class="submitStatus">
        <div class="form-input row">
          <div class="form-input-section">
            <label for="prename">Vorname</label>
            <input type="text" v-model="prename"
                  v-on:input="$v.prename.$touch"
                  v-on:blur="$v.prename.$touch"
                  v-bind:class="{error: $v.prename.$error, valid: $v.prename.$dirty && !$v.prename.$invalid}"
                  placeholder="Ihr Vorname">
            <span v-if="$v.prename.$error">Bitte geben Sie Ihren Vornamen an</span>
          </div>
          <div class="form-input-section">
            <label for="surname">Nachname</label>
            <input type="text" v-model="surname"
                  v-on:input="$v.surname.$touch"
                  v-on:blur="$v.surname.$touch"
                  v-bind:class="{error: $v.surname.$error, valid: $v.surname.$dirty && !$v.surname.$invalid}"
                  placeholder="Ihr Nachname">
             <span v-if="$v.surname.$error">Bitte geben Sie Ihren Nachnamen an</span>
          </div>
        </div>
        <div class="form-input row">
          <div class="form-input-section">
       
          <label for="email">E-Mail</label>
          <input type="email" v-model="email"
                 v-on:input="$v.email.$touch"
                 v-on:blur="$v.email.$touch"
                 v-bind:class="{error: $v.email.$error, valid: $v.email.$dirty && !$v.email.$invalid}"
                 placeholder="Ihre E-Mail Adresse">
          
          <div v-if="$v.email.$error">
            <span v-if="!$v.email.required">Bitte geben Sie Ihre E-Mail Adresse an</span>
            <span v-else-if="!$v.email.email">Bitte geben Sie eine gültige E-Mail Adresse an</span>
          </div>
        </div>
         <div class="form-input-section">
            <label for="request_type">Anliegen</label>
            <select name="dropdown" size="1" v-model="subject"
                    v-on:change="$v.subject.$touch"
                    v-on:blur="$v.subject.$touch"
                    v-bind:class="{error: $v.subject.$error, valid: $v.subject.$dirty && !$v.subject.$invalid}">
              <option value="Ausstellungsbesuch">Ausstellungsbesuch</option>
              <option value="Beratungstermin">Beratungstermin</option>
              <option value="Pflegetipps">Pflegetipps</option>
              <option value="Auftrag">Auftrag</option>
            </select>
            <div v-if="$v.subject.$error">
              <span v-if="!$v.subject.required">Bitte wählen Sie ein Anliegen aus</span>
            </div>
          </div>
          </div>
        <div class="form-input">
          <label for="message">Nachricht</label>
          <textarea rows="10" v-model="message"
                 v-on:input="$v.message.$touch"
                 v-on:blur="$v.message.$touch"
                 v-bind:class="{error: $v.message.$error, valid: $v.message.$dirty && !$v.message.$invalid}"
                 placeholder="Ihr Nachricht an uns"
          ></textarea>
          <div v-if="$v.message.$error">
            <span v-if="!$v.message.required">Bitte geben Sie eine Nachricht ein</span>
            <span v-else-if="!$v.message.minLength">Die Nachricht sollte mindestens {{ $v.message.$params.minLength.min }} Zeichen haben</span>
            <span v-else-if="!$v.message.maxLength">Die Nachricht sollte maximal {{ $v.message.$params.maxLength.max }} Zeichen haben</span>
        </div>
        </div>
        <div class="form-input privacy">
          <input type="checkbox" v-model="dataPrivacy"
                 v-on:change="$v.dataPrivacy.$touch"
                 v-bind:class="{error: $v.dataPrivacy.$error, valid: $v.dataPrivacy.$dirty && !$v.dataPrivacy.$invalid}"
          >
          <label for="dataPrivacy">Ich willige darin ein, dass die Marmor Kunze GmbH die von mir überreichten Informationen und Kontaktdaten dazu verwendet um mit mir anlässlich meiner Kontaktaufnahme in Verbindung zu treten, hierüber zu kommunizieren und meine Anfrage abzuwickeln. Dies gilt insbesondere für die Verwendung der E-Mail-Adresse zum vorgenannten Zweck. Die Datenschutzerklärung kann <router-link :to="{ name: 'Datenschutz' }" style="text-decoration:underline">hier</router-link> eingesehen werden.</label>
          <!-- <div class="break"></div> -->
          <div class="error-message" v-if="$v.dataPrivacy.$error">
            <span v-if="!$v.dataPrivacy.required">Bitte stimmen Sie der Datenschutzerklärung zu.</span>
          </div> 
          </div>
        
      <input type="submit"  :class="{disabled: $v.$invalid}" value="Nachricht senden">
      <span v-if="formError">{{ formErrorMessage}}}</span> 
      </form>
         
    </section>
  </div>
</template>

<script>
import { required, email,minLength,alpha, maxLength } from 'vuelidate/lib/validators'
const axios = require('axios');
const qs = require('qs');
import { mapGetters } from 'vuex'
export default {
  name: 'Kontakt',
  metaInfo: {
    title: 'Kontaktaufnahme',
    meta:[
      { vmid: 'description', name: 'description', content: "Wenn Sie Fragen haben, einen Beratungstermin oder Ausstellungsbesuch vereinbaren wollen, freuen wir uns jederzeit über Ihre Mitteilung!"},
      { vmid: 'keywords', name: 'keywords', content: "Kontakt Marmor Kunze, Beratungstermin, Naturstein Ausstellung, Ausstellungsbesuch, Planung, Naturstein Experte Mönchengladbach"},
      
    ],
    links: [ {rel: 'canonical', href: 'https://www.marmor-kunze.de/kontakt'} ]
  },
  data() {
      return{
        submitStatus: 'wait',
        prename:'',
        surname:'',
        email:'',
        message:'',
        subject: '',
        dataPrivacy: '',
        validForm:false,
        formError: false,
        formErrorMessage: ''
    }
  },
  validations: {
    prename: {
      required,
      alpha
    },
    surname: {
      required,
      alpha
    },
    email:{
      required,
      email
    },
    message:{
      required,
      minLength: minLength(50),
      maxLength: maxLength(200)
    },
    dataPrivacy:{
      required
    },
    subject:{
      required
    }
  },
  created () {
    this.submitStatus = "ready";
  },
  methods:{
    SubmitForm: function(e){
    
     if(!this.$v.$invalid && !this.$v.$error){
       this.submitStatus = "pending"
       let params = {
          prename :this.prename,
          surname: this.surname,
          email: this.email,
          subject: this.subject,
          message: this.message
       }
       axios.post('./php/contact.php', qs.stringify(params, { parseArrays: false })
            ).then( (response) => {
              if(response.data == "submitted"){
                this.submitStatus = "submitted",
                window.scrollTo(0, 0)
                this.$store.dispatch("system/DisableContactForm");
              }else{
                this.submitStatus = "error"
              }
            }).catch( (error) => {
              this.submitStatus = "error"
            });
        return true
      }
      e.preventDefault();
    }
  },
  computed:{
    ...mapGetters({
      formAvailable : "system/contactFormAvailable"
    })
  },
}
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Kontakt.vue